import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import { ReactNodeViewRenderer } from '@tiptap/react';
import CodeBlockView from '../components/chapter/CodeBlockView/CodeBlockView';

// CodeBlockEnhanced — CodeBlockLowlight + React NodeView (in-block language
// picker) + Tab/Shift-Tab indent. Stays serialized as a standard fenced code
// block on the markdown wire, so server-side hub logic is unchanged.
const CodeBlockEnhanced = CodeBlockLowlight.extend({
  addNodeView() {
    return ReactNodeViewRenderer(CodeBlockView);
  },

  addKeyboardShortcuts() {
    return {
      ...this.parent?.(),
      Tab: () => {
        if (!this.editor.isActive('codeBlock')) return false;
        return this.editor.commands.insertContent('\t');
      },
      'Shift-Tab': () => {
        if (!this.editor.isActive('codeBlock')) return false;
        const { state, view } = this.editor;
        const { $from } = state.selection;
        if ($from.parentOffset === 0) return false;
        const prev = state.doc.textBetween($from.pos - 1, $from.pos);
        if (prev !== '\t') return false;
        view.dispatch(state.tr.delete($from.pos - 1, $from.pos));
        return true;
      },
    };
  },
});

export default CodeBlockEnhanced;
